import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import {
    loadContractDetailsForContractIds,
    loadDataSetDetails,
    loadParticipantStatusDetails
} from '../../store/directusService';
import { clearParticipantsSearch } from '../../store/participantService';

import DataSetsModal from './dataSetsModal/DataSetsModal';

const DataSets = ({ isOpen, onClose }) => {
    const dispatch = useDispatch();

    // LOCAL STATE
    const [isDataSetsModalOpen, setIsDataSetsModalOpen] = useState(false);

    // STORE STATE
    const loggedInUser = useSelector((state) => state.entities.userService.loggedInUser);
    const dataSets = useSelector((state) => state.entities.directusService.dataSetDetails);
    const contracts = useSelector((state) => state.entities.directusService.contractDetails);
    const participantStatusDetails = useSelector(
        (state) => state.entities.directusService.participantStatusDetails
    );

    // USE EFFECTS
    useEffect(() => {
        if (dataSets?.length < 1) dispatch(loadDataSetDetails());
        if (participantStatusDetails?.length < 1) dispatch(loadParticipantStatusDetails());
    }, []);

    useEffect(() => {
        loggedInUser?.contractIds &&
            dispatch(loadContractDetailsForContractIds(loggedInUser.contractIds));
    }, [loggedInUser]);

    useEffect(() => {
        setIsDataSetsModalOpen(isOpen);
    }, [isOpen]);

    // EVENT HANDLERS
    const onDataSetsModalClose = () => {
        dispatch(clearParticipantsSearch());
        setIsDataSetsModalOpen(false);
        onClose();
    };

    // RENDER
    return (
        <DataSetsModal
            dataSets={dataSets}
            contracts={contracts}
            isOpen={isDataSetsModalOpen}
            onCancel={onDataSetsModalClose}
        />
    );
};

DataSets.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func
};

export default DataSets;
